<template>
  <v-col :cols="attrs.cols">
    <div class="naming">
      <div v-if="attrs.add" class="mb-4 flex-wrap">
        <v-btn
          v-if="attrs.controls"
          class="mr-2"
          light
          rounded
          x-small
          @click="hideChildren = !hideChildren"
          >{{ hideChildren ? "All" : "Compact" }}</v-btn
        >

        <v-btn
          v-if="attrs.controls"
          class=" ml-2 mr-2"
          light
          rounded
          x-small
          @click="editMode = !editMode"
          >{{ editMode ? "Close" : "Edit" }}</v-btn
        >

        <v-btn
          v-if="attrs.controls && !editMode"
          class="ml-2 mr-2"
          light
          rounded
          x-small
          @click="deleteList()"
          >Delete</v-btn
        >
        <v-btn
          v-if="editMode && attrs.controls"
          class="ml-2"
          light
          rounded
          x-small
          color="amber"
          @click="applyNameChange"
          >Apply</v-btn
        >
      </div>
      <div class="naming__header">
        <div
          v-if="editMode === false"
          class="d-flex justify-space-between align-items-center"
        >
          <div class="mb-4">
            <p class="headline">{{ item.title }}</p>
            <v-chip v-if="item.logo" small light color="amber">Logo</v-chip>
            <div class="d-flex mt-4">
              <v-chip
                v-for="(tag, index) in item.audiences"
                :key="`tag-${tag}-${index}`"
                small
                class="mr-2"
              >
                {{ tag }}</v-chip
              >
            </div>
            <div v-if="attrs.note" v-text="item.body" class="mt-4"></div>
          </div>
        </div>

        <div v-else>
          <ColForm
            :key="refItem.id"
            :new-item="refItem"
            :audiences="attrs.audiences"
            @update="updateList"
          />
        </div>
        <div
          v-if="!editMode && attrs.controls && attrs.add"
          class="d-flex justify-space-between"
        >
          <v-btn
            @click="cardForm = !cardForm"
            :color="cardForm ? 'grey' : 'amber'"
            class="mb-4"
            light
            rounded
            small
            >{{ cardForm ? "Close" : "+" }}</v-btn
          >
        </div>

        <v-card v-if="cardForm" class="mb-4" elevation="2" outlined light>
          <v-card-title>Add a new item</v-card-title>
          <v-card-text>
            <ItemForm
              :key="newItem.id"
              :new-item="newItem"
              :colors="colors"
              :audiences="attrs.audiences"
              @submit="addItem"
              @cancel="cancel"
            />
          </v-card-text>
        </v-card>

        <div v-if="items">
          <NestedDraggable
            :children="items"
            :item-model="proto"
            :attrs="attrs"
            :depth="0"
            :id="item.id"
            :hide-children="hideChildren"
          />
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
// @ is an alias to /src
import NestedDraggable from "@/views/user/exercises/eco-system/NestedDraggable";
import ItemForm from "@/views/user/exercises/eco-system/ItemForm";
import ColForm from "@/views/user/exercises/eco-system/ColForm";
import { checkPopulated } from "@/utils/types";

const itemModel = {
  id: "",
  name: "",
  body: "",
  label: "",
  color: "",
  index: "",
  edit: false,
  logo: false,
  allowPrefix: "",
  audiences: [],
  children: [],
};

export default {
  name: "UserServiceCol",
  components: {
    NestedDraggable,
    ItemForm,
    ColForm,
  },
  data() {
    return {
      items: this.value,
      refItem: this.item,
      newItem: {
        ...itemModel,
      },
      proto: itemModel,
      editMode: false,
      hideChildren: false,
      cardForm: false,
      colors: [
        { title: "None", color: "" },
        { title: "Red", color: "#F44336" },
        { title: "Pink", color: "#E91E63" },
        { title: "Purple", color: "#9C27B0" },
        { title: "Dark Purple", color: "#673AB7" },
        { title: "Indigo", color: "#3F51B5" },
        { title: "Blue", color: "#2196F3" },
        { title: "Cyan", color: "#00BCD4" },
        { title: "Teal", color: "#009688" },
        { title: "Green", color: "#4CAF50" },
        { title: "Lime", color: "#CDDC39" },
        { title: "Amber", color: "#FFC107" },
        { title: "Orange", color: "#FF9800" },
        { title: "Grey", color: "#607D8B" },
      ],
    };
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      deafult: () => {},
    },
  },
  watch: {
    value: {
      handler(val) {
        this.items = val;
      },
      deep: true,
    },
    items: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    item: {
      handler(val) {
        // watch when a new item is passed from the parent and update our reference item
        this.refItem = val;
      },
      deep: true,
    },
    // refItem: {
    //   handler(val) {
    //     this.$emit("onEditList", val);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    applyNameChange() {
      console.log("applyNameChange");
      // this will emit the new refItem abck to the parent to ass in the updated item into this component
      this.$emit("onChangeName", {
        newTitle: this.refItem.title,
        ...this.refItem,
      });
      this.editMode = false;
    },
    deleteList() {
      this.$emit("onDeleteList", this.item);
    },
    addItem(ev) {
      console.log("add item", ev);
      const item = this.constructItem(itemModel, ev);
      item.id = new Date().valueOf();
      this.items.push(item);
      this.cardForm = false;
      this.newItem = { ...itemModel };
      this.$emit("onEditList", ev);
    },
    cancel() {
      this.cardForm = false;
    },
    constructItem(model, item) {
      const obj = {};
      Object.keys(model).forEach((key) => {
        obj[key] = checkPopulated(item[key]);
      });

      return obj;
    },
    updateList(ev) {
      this.$emit("onEditList", ev);
      this.editMode = false;
    },
  },
};
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}
.naming {
  color: black;
}
</style>
